import login from './login'
import detail from './detail'

const practiceReport = {
  path: 'practice_report',
  component: resolve => require(['../../../../../pages/portal/sbs/exam/practice-report'], resolve),
  children: [
    login,
    detail
  ]
}

export default practiceReport
